import { render, staticRenderFns } from "./AddTeacher.vue?vue&type=template&id=322d7903&"
import script from "./AddTeacher.vue?vue&type=script&lang=js&"
export * from "./AddTeacher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports